/**
 * AbilityPage Component
 * Placeholder for student ability portrait feature
 */

import React from 'react';
import { Construction } from 'lucide-react';

export const AbilityPage: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 p-6">
      <div className="max-w-md w-full bg-white dark:bg-gray-800 rounded-xl shadow-lg p-8 text-center">
        <div className="mb-6">
          <Construction className="mx-auto h-16 w-16 text-yellow-500" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">
          学生能力画像
        </h2>
        <p className="text-gray-600 dark:text-gray-400 mb-2">
          功能开发中...
        </p>
        <p className="text-sm text-gray-500 dark:text-gray-500">
          即将推出学生能力分析、知识点掌握情况等功能
        </p>
      </div>
    </div>
  );
};
